export default __webpack_public_path__ + "static/media/Genitals.4a86865a.svg";